import React from "react";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import ButtonLogin from "components/ButtonLogin/ButtonLogin";
import { useLoginContext } from "context/login-context";
import { useLoginHook } from "hooks/login-hook";
import Loader from 'components/Login/Loader/Loader';
import { IErrorMessageLogin } from "models/login";
import { ReactComponent as Arrow } from "assets/img/arrow-right.svg";

function ButtonSubmit() {
  const {
    checkboxTerms,
    errorMessage,
    isLoading,
    loginData,
    setErrorMessage
  } = useLoginContext();

  const { executeRecaptcha } = useGoogleReCaptcha();

  const loginHook = useLoginHook();
  const inputIsInvalid = loginData?.email === '' || loginData?.password === '' || errorMessage !== '';
  const checkboxIsUnchecked = checkboxTerms?.showCheckbox && !checkboxTerms?.isChecked;

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!executeRecaptcha) {
      setErrorMessage(IErrorMessageLogin.RECAPTCHA_ERRO_SERVICO);
      return;
    }

    await executeRecaptcha()
      .then(async (token) => {
        await loginHook.validate(event, loginData.email, loginData.password, token);
      })
  };

  return (
    <div>
      <ButtonLogin
        id="botao-login"
        label="Entrar"
        onClick={handleSubmit}
        icon={isLoading ? <Loader className='loader' /> : <Arrow width={24} height={24} />}
        disabled={checkboxIsUnchecked || inputIsInvalid || isLoading}
        alignSelf='flex-end'
        type="with-icon"
      />
    </div>
  );
}

export default ButtonSubmit;